import React, { useRef, useState, useEffect } from "react";
import "./KYC.scss";
import {
  getUserDetails,
} from "../../../util/API/customers";
import KYCItem from "./KYCItem/KYCItem";
import KYCInformation from "./KYCInformation/KYCInformation";
import KYCNoItem from "./KYCNoItem/KYCNoItem";
import { getKYCNCS, updateProfile, addKYC, updateProfileKYC, getSingleKYCDoc } from "../../../util/API/KYC_legacy";
import { useSelector, useDispatch } from "react-redux";
import { setStoreSelectedUser } from "../../../store/redux/users";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { Box, Typography } from "@mui/material";
import { addRejectionNotes } from "../../../util/API/KYC_legacy";

function KYC({ selectedUser, updateTableStatus, handleSelectedUser }) {
  const [selfieSelected, setSelfieSelected] = useState(null);
  const [selectedImageType, setSelectedImageType] = useState("");
  const [infoVisible, setInfoVisible] = useState(false);
  const [passportVisible, setpassportVisible] = useState(false);
  const [doc1Visible, setdoc1Visible] = useState(false);
  const [doc2Visible, setdoc2Visible] = useState(false);
  const [licenseSelected, setLicenseSelected] = useState(false);
  const [kycData, setKycData] = useState(null);
  const [kycSingleDocData, setKycSingleDocData] = useState({
    image:"",
    data:""
  });
  const [userStatus, setUserStatus] = useState("");
  const [alert, setAlert] = useState({
    showAlert: false, 
    severity: '',
    message: '',
    header: ''
  });
  const [isEditing, setIsEditing] = useState({
    passport: false,
    address: false,
    document3: false,
    selfie: false,
  });
  const [isEyeSlash, setIsEyeSlash] = useState({
    passport: false,
    address: false,
    document3: false,
    selfie: false,
  });
  const [loading, setLoading] = useState(true);
  const [uploadLoading, setUploadLoading] = useState({
    passport: false,
    address: false,
    document3: false,
    selfie: false,
  });
  const [updatedDocType, setUpdatedDocType] = useState(null);
  const [updatedDocTypeNew, setUpdatedDocTypeNew] = useState(null);
  const [uploadingDoc, setUploadingDoc] = useState(false);
  

  console.log(kycData)

  const [refresh, setRefresh] = useState(false);
  const [isReject, setIsReject] = useState({
    passport: false,
    doc1: false,
    doc2: false,
    selfie: false,
  });

  let agent = JSON.parse(sessionStorage.getItem("user")).payload.body;

  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);

  const dispatch = useDispatch();
  let selectedUserData = useSelector(
    (state) => state.usersList.selectedUser
  );

  console.log(selectedUserData);

  const previousUserData = useRef(selectedUserData);

  //dockeys
  const [kycImages, setKYCImages] = useState(null);
  const [displayMessage, setDisplayMessage] = useState(false);
  const displayPDF = !!selectedUserData?.User?.other4;

  console.log(selectedUserData)

  const [kycDocs, setKYCDocs] = useState([
    selectedUserData?.User?.other1.split("-")[3],
    selectedUserData?.User?.other2.split("-")[3],
    selectedUserData?.User?.other3.split("-")[3],
    selectedUserData?.User?.other5.split("-")[3]
  ]);

  const [docStatus, setDocStatus] = useState ({
    passport: selectedUserData?.User?.other1.split("-")[2],
    doc1: selectedUserData?.User?.other2.split("-")[2],
    doc2: selectedUserData?.User?.other3.split("-")[2],
    selfie: selectedUserData?.User?.other5.split("-")[2]
  });

  console.log(docStatus)
  console.log(kycDocs)

  const getKYC = async () => {
    try {
      setLoading(true);
      const response = await getKYCNCS(selectedUserData?.User?.id, kycDocs);
      setKycData(response.sensitiveData);
      setKYCImages({
        passport: response.docs[0],
        doc1: response.docs[1],
        doc2: response.docs[2],
        selfie: response.docs[3],
      });
      
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedUserData?.User?.profilestatus == 2) {
      setUserStatus("Accepted");
    } else if (selectedUserData?.User?.profilestatus == 0) {
      setUserStatus("Rejected");
    } else {
      setUserStatus("Pending");
    }
    getKYC();
  }, [refresh]);

  const licenseImage = null;

  const parseDocStatuses = (kycData) => {
    const statusMap = {
      doc1: 'Rejected',
      doc2: 'Rejected',
      passport: 'Rejected',
      selfie: 'Rejected'
    };
  
    kycData?.forEach(item => {
      if (!item) return;
      const [userid, datatype, docstring] = item.sensitiveData.split('|');
      const parts = docstring.split('-');
      const state = parts[2]; // e.g., 2 means Accepted
  
      const fieldKey = (() => {
        if (item.datatype === '1') return 'doc1';
        if (item.datatype === '2') return 'passport';
        if (item.datatype === '3') return 'doc2';
        if (item.datatype === '4') return 'selfie';
      })();
  
      if (fieldKey) {
        statusMap[fieldKey] = state === '2' ? 'Accepted' : state === '1' ? 'Pending' : 'Rejected';
      }
    });
  
    return statusMap;
  };

  const determineProfileStatus = (kycData, updatedField, newStatus) => {
    // console.log("kycData----------updatedField---------------",updatedField);
    const docStatusMap = {
      other1: 'Rejected', // Passport
      other2: 'Rejected', // Doc1
      other3: 'Rejected', // Doc2
      other5: 'Rejected', // Selfie
    };
  
    kycData?.forEach((item) => {
      if (!item) return;
      const { dataid, sensitiveData } = item;
      const docParts = sensitiveData.split('|');
      const docString = docParts[2] || '';
      const statusCode = parseInt(docString.split('-')[2], 10);
  
      let statusText = 'Rejected';

  
      // Get the current field for this doc based on dataid
      const currentField =
        item.datatype === '2' ? 'other1' : // Passport
        item.datatype === '1' ? 'other2' : // Doc1
        item.datatype === '3' ? 'other3' : // Doc2
        item.datatype === '4' ? 'other5' : // Selfie
        null;
        
        console.log("kycData----------currentField---------------",currentField);
  
        
        if (!currentField) return;
        
        if (currentField === updatedField) {
          // Use updated status
          statusText = newStatus === 2 ? 'Accepted' : newStatus === 1 ? 'Pending' : 'Rejected';
          docStatusMap[currentField] = statusText;
        } else {
          // Use existing docstring status
          statusText = statusCode === '2' ? 'Accepted' : statusCode === '1' ? 'Pending' : 'Rejected';
          if(item?.datatype == "2") {
            docStatusMap[currentField] = getStatus(docStatus.passport);
          } else if(item?.datatype == "1") {
            docStatusMap[currentField] = getStatus(docStatus.doc1);
          } else if (item?.datatype == "3") {
            docStatusMap[currentField] = getStatus(docStatus.doc2);
          } else if (item?.datatype == "4") {
            docStatusMap[currentField] = getStatus(docStatus.selfie);
          }
        }
      // docStatusMap[currentField] = statusText;
    });
  
    
    const selfieAccepted = docStatusMap.other5 === 'Accepted';
    console.log("kycData----------selfieAccepted---------------",selfieAccepted);
    const otherDocAccepted =
      docStatusMap.other1 === 'Accepted' ||
      docStatusMap.other2 === 'Accepted' ||
      docStatusMap.other3 === 'Accepted';
      
    console.log("kycData----------docStatusMap---------------",docStatusMap);
    console.log("kycData----------otherDocAccepted---------------",otherDocAccepted);
  
    const otherDocPending =
      docStatusMap.other1 === 'Pending' ||
      docStatusMap.other2 === 'Pending' ||
      docStatusMap.other3 === 'Pending';
  
    if (selfieAccepted && otherDocAccepted) {
      return 4; // Profile completed
    } else if (
      (selfieAccepted && otherDocPending) ||
      (!selfieAccepted && (otherDocAccepted || otherDocPending))
    ) {
      return 3; // In progress
    } else {
      return 3; // Incomplete
    }
  };

  const setStatus = async (status, otherField, docString, comment, dataid) => {
    setLoading(true)
    console.log(kycDocs[1]);
    docString = docString.split('-');
    docString[2] = status;
    docString = docString.join('-');

    if (isReject) {
      let notes = dataid + "|" + comment
      const response2 = await addRejectionNotes(selectedUser, agent['User'].id, notes)
      console.log(notes)
      console.log(response2)
    }

    console.log("kycData-------------",kycData);

    const profileStatus = determineProfileStatus(kycData, otherField, status);

    const response = await updateProfileKYC(
      parseInt(selectedUser),
      otherField,
      docString,
      profileStatus,
      status
    );

    if (response.callStatus != 1) {
      setAlert({
        header: 'Error',
        showAlert: true,
        message: 'KYC failed to update',
        severity: 'error'
      });
      return;
    } else {
      setAlert({
        header: 'Success',
        showAlert: true,
        message: 'KYC updated',
        severity: 'success'
      });
    }

    handleUpdate(otherField, status);

    // const response = await updateProfile(parseInt(selectedUser), otherField, docString, status);
    // if (response.callStatus != 1) {
    //   setAlert({
    //     header: 'Error',
    //     showAlert: true,
    //     message: "KYC failed to update",
    //     severity: 'error'
    //   });
    //   return;
    // }
    // else {
    //   setAlert({
    //     header: 'Success',
    //     showAlert: true,
    //     message: "KYC updated",
    //     severity: 'success'
    //   });
    // }
    // handleUpdate(otherField, status);
    setLoading(false)
  };

  const handleUpdate = async (otherField, status) => {
    console.log("otherField-------------",otherField);
    console.log("otherField------------333-",status);
    // setUpdatedDocType(otherField);
    setLoading(true)
    const userDetails = await getUserDetails(selectedUser);
    dispatch(setStoreSelectedUser({selectedUser: userDetails}));

    console.log(userDetails)
    console.log(
      userDetails?.User?.other1.split("-")[3],
      userDetails?.User?.other2.split("-")[3],
      userDetails?.User?.other3.split("-")[3],
      userDetails?.User?.other5.split("-")[3]
    )

    setKYCDocs(
    userDetails?.User?.other1.split("-")[3],
    userDetails?.User?.other2.split("-")[3],
    userDetails?.User?.other3.split("-")[3],
    userDetails?.User?.other5.split("-")[3]
  );
    if (otherField === 'other1') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, passport: status}));
    } else  if (otherField === 'other2') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, doc1: status}));
    } else  if (otherField === 'other3') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, doc2: status}));
    }else  if (otherField === 'other5') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, selfie: status}));
    }

    const response = await getKYCNCS(selectedUserData?.User?.id, [
      userDetails?.User?.other1.split("-")[3],
      userDetails?.User?.other2.split("-")[3],
      userDetails?.User?.other3.split("-")[3],
      userDetails?.User?.other5.split("-")[3]
    ]);
    setKycData(response.sensitiveData);
    setKYCImages({
      passport: response.docs[0],
      doc1: response.docs[1],
      doc2: response.docs[2],
      selfie: response.docs[3],
    });
    await refreshUserDetails();
    setLoading(false)
  }

  const handleUpdate2 = async (otherField, status) => {
    console.log("otherField-------------",otherField);
    console.log("otherField------------333-",status);
    // setUpdatedDocType(otherField);
    setLoading(true)
    const userDetails = await getUserDetails(selectedUser);
    dispatch(setStoreSelectedUser({selectedUser: userDetails}));

    console.log(userDetails)
    console.log(
      userDetails?.User?.other1.split("-")[3],
      userDetails?.User?.other2.split("-")[3],
      userDetails?.User?.other3.split("-")[3],
      userDetails?.User?.other5.split("-")[3]
    )

    setKYCDocs(
    userDetails?.User?.other1.split("-")[3],
    userDetails?.User?.other2.split("-")[3],
    userDetails?.User?.other3.split("-")[3],
    userDetails?.User?.other5.split("-")[3]
  );
    if (otherField === 'other1') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, passport: status}));
    } else  if (otherField === 'other2') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, doc1: status}));
    } else  if (otherField === 'other3') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, doc2: status}));
    }else  if (otherField === 'other5') {
      setDocStatus(
        (prevDetails) => ({...prevDetails, selfie: status}));
    }

    const response = await getKYCNCS(selectedUserData?.User?.id, [
      userDetails?.User?.other1.split("-")[3],
      userDetails?.User?.other2.split("-")[3],
      userDetails?.User?.other3.split("-")[3],
      userDetails?.User?.other5.split("-")[3]
    ]);
    setKycData(response.sensitiveData);
    setKYCImages({
      passport: response.docs[0],
      doc1: response.docs[1],
      doc2: response.docs[2],
      selfie: response.docs[3],
    });
    await refreshUserDetails();

    // if(otherField == "other1") {
    //   setUpdatedDocTypeNew("Passport");
    // } else if(otherField == "other2") {
    //   setUpdatedDocTypeNew("Secondary Identity Document");
    // } else if(otherField == "other2") {
    //   setUpdatedDocTypeNew("Other Identity Document");
    // }
    
    setLoading(false)
  }

  const getStatus = (statusNum) => {
    if (statusNum == 2) {
      return "Accepted";
    } else if (statusNum == 1) {
      return "Pending";
    } else {
      return "Rejected";
    }
  };

  console.log(kycData);
  console.log(kycDocs);
  console.log(userStatus)
  console.log(docStatus)

  const toggleIsEditing = (doctype) => {
    if (doctype === "passport") {
      setIsEditing((prevDetails) => ({...prevDetails, passport: !prevDetails.passport}));
    } else if (doctype === "address") {
      setIsEditing((prevDetails) => ({...prevDetails, address: !prevDetails.address}));
    } else if (doctype === "document3") {
      setIsEditing((prevDetails) => ({...prevDetails, document3: !prevDetails.document3}));
    } else if (doctype === "selfie") {
      setIsEditing((prevDetails) => ({...prevDetails, selfie: !prevDetails.selfie}));
    }
  }

  // const toggleIsEyeSlash = (doctype) => {
  //   if (doctype === "passport") {
  //     setIsEyeSlash((prevDetails) => ({...prevDetails, passport: !prevDetails.passport}));
  //   } else if (doctype === "address") {
  //     setIsEyeSlash((prevDetails) => ({...prevDetails, address: !prevDetails.address}));
  //   } else if (doctype === "document3") {
  //     setIsEyeSlash((prevDetails) => ({...prevDetails, document3: !prevDetails.document3}));
  //   } else if (doctype === "selfie") {
  //     setIsEyeSlash((prevDetails) => ({...prevDetails, selfie: !prevDetails.selfie}));
  //   }
  // }

  useEffect(()=> {
    console.log("kycData==========",kycData);
    console.log("kycData==========22------------",updatedDocType);
    updateSingleDocData();
  }, [kycData])

  // useEffect(()=> {
  //   console.log("kycData==========",kycData);
  //   console.log("kycData==========22------------",updatedDocType);
  //   updateSingleDocDataNew();
  // }, [updatedDocTypeNew])

  const updateSingleDocData = async() => {
    try {
      console.log("updatedDocType----------------------------",updatedDocType);

      setLoading(true);
      if(updatedDocType == "Passport") {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, kycData[0]?.dataid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            data: kycDocResponse.payload || "",
          });
        }
      } else if(updatedDocType == "Secondary Identity Document") {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, kycData[1]?.dataid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            data: kycDocResponse.payload || "",
          });
        }
      } else if(updatedDocType == "Other Identity Document") {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, kycData[2]?.dataid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            data: kycDocResponse.payload || "",
          });
        }
      } else if(updatedDocType == "Selfie") {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, kycData[3]?.dataid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            data: kycDocResponse.payload || "",
          });
        }
      }
    } catch (error) {
      console.log("updateSingleDocData22_error----------",error);
    } finally {
      setLoading(false);
    }
  }

  const updateSingleDocDataNew = async() => {
    try {
      setLoading(true);
      if(updatedDocTypeNew == "Passport") {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, kycData[0]?.dataid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            data: kycDocResponse.payload || "",
          });
        }
      } else if(updatedDocTypeNew == "Secondary Identity Document") {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, kycData[1]?.dataid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            data: kycDocResponse.payload || "",
          });
        }
      } else if(updatedDocTypeNew == "Other Identity Document") {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, kycData[2]?.dataid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            data: kycDocResponse.payload || "",
          });
        }
      }
    } catch (error) {
      console.log("updateSingleDocData22_error----------",error);
    } finally {
      setLoading(false);
    }
  }

  const toggleIsEyeSlash = async(doctype) => {
    setLoading(true)
    console.log("isEyeSlash=--=-=-=========",isEyeSlash);
    console.log("doctype=--=-=-=========",doctype);

    const wasOpen = isEyeSlash[doctype];
    const newIsEyeSlashState = {
      passport: false,
      address: false,
      document3: false,
      selfie: false,
      [doctype]: !wasOpen,
    };

    setIsEditing({
      passport: false,
      address: false,
      document3: false,
      selfie: false
    })

    setIsEyeSlash(newIsEyeSlashState);

    if (newIsEyeSlashState[doctype]) {
      let docid = "";
      if(doctype == "passport") {
        docid = kycDocs[0];
      } else if(doctype == "address") {
        docid = kycDocs[1];
      } else if(doctype == "document3") {
        docid = kycDocs[2];
      } else if(doctype == "selfie") {
        docid = kycDocs[3];
      }
      console.log("docid=--=-=-=========",docid);
      console.log("selectedUserData=--=-=-=========",kycDocs);
  
      try {
        const kycDocResponse = await getSingleKYCDoc(selectedUser, docid);
        if (kycDocResponse?.Status === "1" && kycDocResponse?.callStatus === "1") {
          setKycSingleDocData({
            image: (kycDocResponse.doc || "").split('|')[0] || "",
            // image: kycDocResponse.doc || "",
            data: kycDocResponse.payload || "",
          });
        }
        console.log("kycDocResponse=--=-=-=========",kycDocResponse);
      } catch (error) {
        console.log("kycDocResponse_error=========",error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }

    // setIsEyeSlash((prev) => {
    //   const wasOpen = prev[doctype];
    //   return {
    //     passport: false,
    //     address: false,
    //     document3: false,
    //     selfie: false,
    //     [doctype]: !wasOpen,
    //   };
    // });

      if (doctype === "passport") {
        setdoc1Visible(false)
        setdoc2Visible(false)
        setInfoVisible(false)
        setpassportVisible(true)
      } else if (doctype === "address") {
        setdoc1Visible(true)
        setdoc2Visible(false)
        setInfoVisible(false)
        setpassportVisible(false)
      } else if (doctype === "document3") {
        setdoc1Visible(false)
        setdoc2Visible(true)
        setInfoVisible(false)
        setpassportVisible(false)
      } else if (doctype === "selfie") {
        setdoc1Visible(false)
        setdoc2Visible(false)
        setInfoVisible(true)
        setpassportVisible(false)
      }
  };

  console.log(isEyeSlash)

  const uploadPhoto = async(selectedBase64Image, doctype, docname, idNum, PIN, agentID, togglename) => {
    console.log("uploadPhoto=============docname====",docname);
    console.log("uploadPhoto=============doctype====",doctype);
    console.log("uploadPhoto=============kycdata====",kycData);
    try {
      setLoading(true);
      if (togglename === "address") {
        setUploadLoading({
          ...uploadLoading,
          address: true
        });
      } else if (togglename === "document3") {
        setUploadLoading({
          ...uploadLoading,
          document3: true
        });
      } else if (togglename === "selfie") {
        setUploadLoading({
          ...uploadLoading,
          selfie: true
        });
      }
      else if (togglename === "passport") {
        setUploadLoading({
          ...uploadLoading,
          passport: true
        });
      }
  
      let otherField = null;
  
      switch (doctype) {
        case "Passport":
          otherField = "other1";
          break;
        case "Secondary Identity Document":
          otherField = "other2";
          break;
        case "Other Identity Document":
          otherField = "other3";
          break;
        case "Selfie":
          otherField = "other5";
          break;
        default:
          otherField = ""; // keep existing if no match
      }
  
      console.log(docname)
      
      const profileStatus = await determineProfileStatus(kycData, otherField, 1);
      console.log("uploadPhoto=============profileStatus====",profileStatus);
  
      let response; // ← Declare response here
  
      if (selectedBase64Image) {
        setUploadingDoc(true);
        response = await addKYC(
          selectedUser,
          doctype,
          selectedBase64Image,
          'jpg',
          '',
          docname,
          idNum,
          '',
          '',
          '',
          '',
          PIN,
          agentID,
          profileStatus
        );
        console.log(response)
        if (response.callStatus === '1') {
          await refreshUserDetails();
          setRefresh(!refresh);
          setAlert({
            header: 'Success',
            showAlert: true,
            message: "KYC updated",
            severity: 'success'
          });
  
          toggleIsEditing(togglename)
          toggleIsEyeSlash(togglename)
          setUpdatedDocType(doctype)
  
          if (pinConfiguration === "once") {
            sessionStorage.setItem("pin", PIN);
          }
        }
        else {
          const message = response?.payload ? response.payload.msg : response.msg
          setAlert({
            header: 'Error',
            showAlert: true,
            message: "KYC Upload Failed: " + message,
            severity: 'error'
          });
        }
      }
      setUploadLoading({
        ...uploadLoading,
        address: false,
        document3: false,
        selfie: false,
        passport: false
      });
      return response; // ← Now response is defined
    } catch (error) {
      console.log("error--------------");
    } finally {
      setLoading(false);

    }

  }

  const refreshUserDetails = async () => {
    setLoading(true)
    try {
      const userDetails = await getUserDetails(selectedUser);
      dispatch(setStoreSelectedUser({ selectedUser: userDetails }));
      previousUserData.current = userDetails; // Update the ref to avoid redundant fetches
  
      setKYCDocs([
        userDetails?.User?.other1?.split('-')[3],
        userDetails?.User?.other2?.split('-')[3],
        userDetails?.User?.other3?.split('-')[3],
        userDetails?.User?.other5?.split('-')[3]
      ]);
  
      setDocStatus({
        passport: userDetails?.User?.other1?.split('-')[2],
        doc1: userDetails?.User?.other2?.split('-')[2],
        doc2: userDetails?.User?.other3?.split('-')[2],
        selfie: userDetails?.User?.other5?.split('-')[2],
      });
  
      const kycResponse = await getKYCNCS(userDetails?.User?.id, kycDocs);
      setKycData(kycResponse.sensitiveData);
      setKYCImages({
        passport: kycResponse.docs[0],
        doc1: kycResponse.docs[1],
        doc2: kycResponse.docs[2],
        selfie: kycResponse.docs[3],
      });
    } catch (error) {
      console.error('Failed to refresh user details:', error);
      setAlert({
        header: 'Error',
        showAlert: true,
        message: 'Failed to update user details',
        severity: 'error',
      });
    }
    setLoading(false)
  };

  useEffect(() => {
    refreshUserDetails()
  }, [refresh])

  useEffect(()=> {
    setUploadingDoc(false);
  },[])
  

  console.log(kycDocs)
  console.log(kycData)
  console.log("kycImage--------------2----------",kycSingleDocData);

  return (
    <>
        {loading && (
          <div className="kyc-overlay">
            <span className="loader" />
          </div>
        )}

        <Box 
          sx={{
            display: 'flex', 
            flexDirection: 'column', 
            flexWrap: 'wrap', 
            width: '100%', 
            paddingRight: "0px",
            // paddingRight: "100px",
          }}
        >
          <Box 
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography 
              sx={{  
                fontSize: ['0.875rem', '1rem'],
                color: "#DC3545",
                fontFamily: "Nunito",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "33.6px",
                whiteSpace: "nowrap",  
                overflow: "hidden",     
                textOverflow: "ellipsis", 
                // paddingRight: "270px",
                // '@media (min-width: 1920px)': {
                //   paddingRight: "450px",
                // },
              }} 
            >
              SECURITY: This is Personal Identifiable Information. The Data is confidential.
            </Typography>
          </Box>
          <Box className="kyc-container mb-4" sx={{ overflowX: 'hidden' }}>
            <Box className="KYC-ID-box">
              KYC Identification ID: {selectedUserData?.User?.other5}
            </Box>
            {kycData && kycData[0] !== null && kycDocs[0] != null ? (
              <KYCItem
                docType={kycData[0]?.notes}
                status={getStatus(docStatus.passport)}
                selectedImage={kycSingleDocData}
                // selectedImage={kycImages?.passport?.split('|')[0]}
                onPending={() => {
                    setUploadLoading({...uploadLoading, passport: true})
                    setStatus(1, "other1", selectedUserData?.User?.other1)
                    setUploadLoading({...uploadLoading, passport: false})
                  }
                }
                onAccept={() => {
                    setUploadLoading({...uploadLoading, passport: true})
                    setStatus(2, "other1", selectedUserData?.User?.other1)
                    setUploadLoading({...uploadLoading, passport: false})
                  }
                }
                onReject={() => {
                  setIsReject({...isReject, passport: !isReject.passport})
                  setpassportVisible(false);
                }
                }
                onSelect={() => {setpassportVisible(!passportVisible); setIsReject({...isReject, passport: false})}}
                isSelect={passportVisible}
                isReject={isReject.passport}
                isEyeSlash={isEyeSlash.passport}
                setIsEyeSlash={toggleIsEyeSlash}
                docname={"passport"}
                uploadLoading={uploadLoading.passport}
              />
            ) : (
              <KYCNoItem
                docType="Passport"
                selectedUser={selectedUser}
                groupid={1}
                docname={"passport"}
                setKycData={setKycData}
                uploadPhoto={uploadPhoto}
                uploadLoading={uploadLoading.passport}
              />
            )}
            {(passportVisible || isReject.passport) && loading==false && setAlert !== undefined && (
              <KYCInformation
                // selectedImage={kycImages?.passport?.split('|')[0]}
                selectedImage={kycSingleDocData}
                selectedUser={selectedUser}
                groupid={1}
                docname={"Passport"}
                docType={"passport"}
                setKycData={setKycData}
                hideDocNumber={false}
                docNumber={selectedUserData?.User?.other5}
                handleUpdate={handleUpdate}
                isReject={!passportVisible ? isReject.passport : false}
                handleIsReject={() => setIsReject({...isReject, passport: false})}
                onReject={(comment) => {
                    setUploadLoading({...uploadLoading, passport: true})
                    console.log(comment)
                    setStatus(3, "other1", selectedUserData?.User?.other1, comment, kycData[0]?.dataid)
                    setUploadLoading({...uploadLoading, passport: false})
                  }
                }
                kycData={kycData[0]}
                status={getStatus(docStatus?.passport)}
                isEditing={isEditing.passport}
                setIsEditing={toggleIsEditing}
                selfieChange={uploadPhoto}
                uploadLoading={uploadLoading.passport}
                handleSelectedUser={handleSelectedUser}
                setIsEyeSlash={setIsEyeSlash}
                setdoc1Visible={setdoc1Visible}
                setdoc2Visible={setdoc2Visible}
                setInfoVisible={setInfoVisible}
                setpassportVisible={setpassportVisible}
                refreshUserDetails={refreshUserDetails}
                setKycAlert={setAlert}
                setLoading={setLoading}
              />
            )}

            {kycData && kycData[1] !== null  && kycDocs && kycDocs[1] !== null ? (
              console.log(kycDocs),
              <KYCItem
              docType={kycData[1]?.sensitiveData?.split("|")[3] || "KYC Document 2"}
              status={getStatus(docStatus.doc1)}
                // selectedImage={kycImages?.doc1?.split('|')[0]}
                selectedImage={kycSingleDocData}
                onPending={() => {
                    setUploadLoading({...uploadLoading, address: true})
                    setStatus(1, "other2", selectedUserData?.User?.other2)
                    setUploadLoading({...uploadLoading, passport: false})
                  }
                }
                onAccept={() => {
                    setUploadLoading({...uploadLoading, address: true})
                    setStatus(2, "other2", selectedUserData?.User?.other2)
                    setUploadLoading({...uploadLoading, address: false})
                  }
                }
                onReject={() => {
                  setIsReject({...isReject, doc1: !isReject.doc1})
                  setdoc1Visible(false);
                }}
                onSelect={() => {setdoc1Visible(!doc1Visible); setIsReject({...isReject, doc1: false})}}
                isSelect={doc1Visible}
                isReject={isReject.doc1}
                isEyeSlash={isEyeSlash.address}
                setIsEyeSlash={toggleIsEyeSlash}
                docname={"address"}
                uploadLoading={uploadLoading.address}
              />
            ) : (
              <KYCNoItem
                docType="Secondary Identity Document"
                selectedUser={selectedUser}
                groupid={2}
                docname={"address"}
                setKycData={setKycData}
                uploadPhoto={uploadPhoto}
                uploadLoading={uploadLoading.address}
              />
            )}
            {(doc1Visible || isReject.doc1) && (
              <KYCInformation
                // selectedImage={kycImages?.doc1?.split('|')[0]}
                selectedImage={kycSingleDocData}
                selectedUser={selectedUser}
                groupid={2}
                docname={kycData[1]?.sensitiveData?.split("|")[3]}
                setKycData={setKycData}
                docType={"address"}
                hideDocNumber={true}
                displayPDF={false}
                isReject={!doc1Visible ? isReject.doc1 : false}
                handleIsReject={() => setIsReject({...isReject, doc1: false})}
                handleUpdate={handleUpdate}
                onReject={(comment) => {
                  setUploadLoading({...uploadLoading, address: true})
                  console.log(comment)
                  setStatus(3, "other2", selectedUserData?.User?.other2, comment, kycData[1]?.dataid)
                  setUploadLoading({...uploadLoading, address: false})
                }}
                kycData={kycData[1]}
                status={getStatus(docStatus.doc1)}
                isEditing={isEditing.address}
                setIsEditing={toggleIsEditing}
                selfieChange={uploadPhoto}
                uploadLoading={uploadLoading.address}
                handleSelectedUser={handleSelectedUser}
                setIsEyeSlash={setIsEyeSlash}
                setdoc1Visible={setdoc1Visible}
                setdoc2Visible={setdoc2Visible}
                setInfoVisible={setInfoVisible}
                setpassportVisible={setpassportVisible}
                refreshUserDetails={refreshUserDetails}
                setKycAlert={setAlert}
                setLoading={setLoading}
              />
            )}

            {kycData && kycData[2] !== null  && kycDocs && kycDocs[2] !== null ? (
              console.log(kycDocs),
              <KYCItem
                docType={kycData[2]?.sensitiveData?.split("|")[3] || "KYC Document 3"}
                status={getStatus(docStatus.doc2)}
                // selectedImage={kycImages?.doc2?.split('|')[0]}
                onPending={() => {
                    setUploadLoading({...uploadLoading, document3: true})
                    setStatus(1, "other3", selectedUserData?.User?.other3)
                    setUploadLoading({...uploadLoading, document3: false})
                  }
                }
                onAccept={() => {
                    setUploadLoading({...uploadLoading, document3: true})
                    setStatus(2, "other3", selectedUserData?.User?.other3)
                    setUploadLoading({...uploadLoading, document3: false})
                  }
                }
                onReject={() => {
                  setIsReject({...isReject, doc2: !isReject.doc2})
                  setdoc2Visible(false);
                }}
                onSelect={() => {setdoc2Visible(!doc2Visible); setIsReject({...isReject, doc2: false})}}
                isSelect={doc2Visible}
                isReject={isReject.doc2}
                isEyeSlash={isEyeSlash.document3}
                setIsEyeSlash={toggleIsEyeSlash}
                docname={"document3"}
                uploadLoading={uploadLoading.document3}
              />
            ) : (
              <KYCNoItem
                docType="Other Identity Document"
                selectedUser={selectedUser}
                groupid={2}
                docname={"document3"}
                setKycData={setKycData}
                uploadPhoto={uploadPhoto}
                uploadLoading={uploadLoading.document3}
              />
            )}
            {(doc2Visible || isReject.doc2) && (
              <KYCInformation
                // selectedImage={kycImages?.doc2?.split('|')[0]}
                selectedImage={kycSingleDocData}
                selectedUser={selectedUser}
                groupid={3}
                docname={kycData[2]?.sensitiveData?.split("|")[3]}
                docType={"document3"}
                setKycData={setKycData}
                hideDocNumber={true}
                displayPDF={false}
                isReject={!doc2Visible ? isReject.doc2 : false}
                handleIsReject={() => setIsReject({...isReject, doc2: false})}
                handleUpdate={handleUpdate}
                onReject={(comment) => {
                  setUploadLoading({...uploadLoading, document3: true})
                  console.log(comment)
                  setStatus(3, "other3", selectedUserData?.User?.other3, comment, kycData[2]?.dataid)
                  setUploadLoading({...uploadLoading, document3: false})
                }}
                kycData={kycData[2]}
                status={getStatus(docStatus.doc2)}
                isEditing={isEditing.document3}
                setIsEditing={toggleIsEditing}
                selfieChange={uploadPhoto}
                uploadLoading={uploadLoading.document3}
                handleSelectedUser={handleSelectedUser}
                setIsEyeSlash={setIsEyeSlash}
                setdoc1Visible={setdoc1Visible}
                setdoc2Visible={setdoc2Visible}
                setInfoVisible={setInfoVisible}
                setpassportVisible={setpassportVisible}
                refreshUserDetails={refreshUserDetails}
                setKycAlert={setAlert}
                setLoading={setLoading}
              />
            )}

            {kycData && kycData[3] !== null && kycDocs && kycDocs[3] != null && kycDocs[3].length > 0 ? (
              console.log(infoVisible),
              <KYCItem
                docType={"Selfie" || kycData[3]?.notes}
                status={getStatus(docStatus.selfie)}
                // selectedImage={kycImages?.selfie?.split('|')[0]}
                onPending={() => {
                    setUploadLoading({...uploadLoading, selfie: true})
                    setStatus(1, "other5", selectedUserData?.User?.other5)
                    setUploadLoading({...uploadLoading, selfie: false})
                  }
                }
                onAccept={() => {
                    setUploadLoading({...uploadLoading, selfie: true})
                    setStatus(2, "other5", selectedUserData?.User?.other5)
                    setUploadLoading({...uploadLoading, selfie: false})
                  }
                }
                onReject={() => {
                  setIsReject({...isReject, selfie: !isReject.selfie})
                  setInfoVisible(false);
                }}
                onSelect={() => {setInfoVisible(!infoVisible); setIsReject({...isReject, selfie: false})}}
                isSelect={infoVisible}
                isReject={isReject.selfie}
                isEyeSlash={isEyeSlash.selfie}
                setIsEyeSlash={toggleIsEyeSlash}
                docname={"selfie"}
                uploadLoading={uploadLoading.selfie}
              />
            ) : (
              <KYCNoItem
                docType="Selfie"
                selectedUser={selectedUser}
                groupid={4}
                docname={"selfie"}
                setKycData={setKycData}
                uploadPhoto={uploadPhoto}
                uploadLoading={uploadLoading.selfie}
              />
            )}
            {(infoVisible || isReject.selfie) && (
              <KYCInformation
                // selectedImage={kycImages?.selfie?.split('|')[0]}
                selectedImage={kycSingleDocData}
                selectedUser={selectedUser}
                groupid={4}
                docname={"Selfie"}
                docType={"selfie"}
                setKycData={setKycData}
                hideDocNumber={true}
                displayPDF={false}
                isReject={!infoVisible ? isReject.selfie : false}
                handleIsReject={() => setIsReject({...isReject, selfie: false})}
                onReject={(comment) => {
                  setUploadLoading({...uploadLoading, selfie: true})
                  console.log(comment)
                  setStatus(3, "other5", selectedUserData?.User?.other5, comment, kycData[3]?.dataid)
                  setUploadLoading({...uploadLoading, selfie: false})
                }}
                handleUpdate={handleUpdate}
                kycData={kycData[3]}
                status={getStatus(docStatus.selfie)}
                isEditing={isEditing.selfie}
                setIsEditing={toggleIsEditing}
                selfieChange={uploadPhoto}
                uploadLoading={uploadLoading.document3}
                handleSelectedUser={handleSelectedUser}
                setIsEyeSlash={setIsEyeSlash}
                setdoc1Visible={setdoc1Visible}
                setdoc2Visible={setdoc2Visible}
                setInfoVisible={setInfoVisible}
                setpassportVisible={setpassportVisible}
                refreshUserDetails={refreshUserDetails}
                setKycAlert={setAlert}
                setLoading={setLoading}
              />
            )}
            {
              licenseImage != null && licenseImage.length > 0 ? (
                <KYCItem
                  docType="Driver’s License"
                  // selectedImage={kycDocs[0]}
                  onPending={() =>
                    setStatus(kycData.payload[3].body.record.Userkycdocs, 1)
                  }
                  onAccept={() =>
                    setStatus(kycData.payload[3].body.record.Userkycdocs, 2)
                  }
                  onReject={() =>
                    setIsReject(true)
                  }
                  onSelect={() => setInfoVisible(!infoVisible)}
                ></KYCItem>
              ) : (
                <></>
              )
            }
            {selectedImageType === "license" && infoVisible && (
              <KYCInformation selectedImage={licenseSelected} />
            )}
            
          </Box>
          <CustomAlert 
            severity={alert.severity} 
            show={alert.showAlert} 
            header={alert.header} 
            message={alert.message} 
            onClick={(prevDetails) => {
              if (alert.severity === "success") {
                updateTableStatus();
              }
              setAlert({...prevDetails, showAlert: false});
            }}
            autoclose={alert.severity === "error" ? false : true}
          />
        </Box>      
    </>
  );
}

export default KYC;